import shouldSkipProcessRow from './helpers/shouldSkipProcessRow';
import fetchRichContentForRows from './helpers/fetchRichContentForRows';
import { getRowKeyFromListViewType, MailListRowDataType, TableView } from 'owa-mail-list-store';
import updateInstrumentationContext from 'owa-mail-list-store/lib/utils/updateInstrumentationContext';
import TableOperations from 'owa-mail-list-table-operations';
import { isUnpinnedNudgedRow } from 'owa-mail-nudge-store';
import { InstrumentationContext } from 'owa-mail-store';
import { action } from 'satcheljs/lib/legacy';

export default action('appendRowResponse')(
    /**
     * Process FindConversation/FindItem response and append them to the end of the given TableView
     * @param tableView to append results in
     * @param rows to be appended
     * @param totalRowsInViewInResponse - total rows in the table returned from server
     * @param searchResponseId - the search query id
     */
    function appendRowResponse(
        tableView: TableView,
        rows: MailListRowDataType[],
        totalRowsInViewInResponse: number,
        searchResponseId?: string
    ) {
        const rowList: MailListRowDataType[] = rows || [];

        for (const row of rowList) {
            // Check if row should be processed
            if (shouldSkipProcessRow(row, tableView)) {
                continue;
            }

            // Append all rows to end of table
            if (
                TableOperations.containsRowKey(
                    tableView,
                    getRowKeyFromListViewType(row, tableView.tableQuery.listViewType)
                )
            ) {
                // unpinned nudged rows will stay in place and not move down
                const insertIndex = isUnpinnedNudgedRow(row.InstanceKey, tableView)
                    ? tableView.rowKeys.indexOf(row.InstanceKey)
                    : tableView.rowKeys.length - 1;

                // Move row to new position in table if it already exists. There could be some timing issue
                // where the row was moved down on the server. In this case we want to keep the server's latest order
                TableOperations.updateRow(insertIndex, row, tableView);
            } else {
                TableOperations.appendRow(row, tableView);
            }

            if (searchResponseId) {
                const instrumentationContext = <InstrumentationContext>{
                    referenceKey: row.ReferenceKey,
                    index: tableView.rowKeys.length - 1,
                    traceId: searchResponseId,
                };

                updateInstrumentationContext(row.InstanceKey, tableView, instrumentationContext);
            }
        }

        // VSO 1285: optimize this number on empty folder
        tableView.totalRowsInView = totalRowsInViewInResponse; // Sketch: does this belong here?

        // FetchRichContentForRows
        fetchRichContentForRows(tableView);
    }
);
